export function getCloudflareUnavailableMessage(
  error: unknown,
  fallbackMessage: string,
  corsMessage: string,
): string {
  const message = error instanceof Error ? error.message : String(error || "");

  if (
    error instanceof TypeError ||
    message.toLowerCase().includes("cors") ||
    message.toLowerCase().includes("cross-origin")
  ) {
    return corsMessage;
  }

  return fallbackMessage;
}
